import 'reflect-metadata';
import {
  Expose,
  plainToInstance,
  instanceToPlain,
  Type,
} from 'class-transformer';

export class Event {
  id: number;

  title: string;

  venue: string;

  about: string;

  @Expose({ name: 'image_preview' })
  imagePreview: string;

  tag?: string;

  @Expose({ name: 'start_date' })
  @Type(() => Date)
  startDate: Date;

  @Expose({ name: 'end_date' })
  @Type(() => Date)
  endDate?: Date;

  @Expose({ name: 'updated_at' })
  @Type(() => Date)
  updatedAt?: Date;

  constructor(
    id: number,
    title: string,
    venue: string,
    about: string,
    imagePreview: string,
    tag: string | undefined,
    startDate: Date,
    endDate: Date | undefined,
    updatedAt: Date | undefined
  ) {
    this.id = id;
    this.title = title;
    this.venue = venue;
    this.about = about;
    this.imagePreview = imagePreview;
    this.tag = tag;
    this.startDate = startDate;
    this.endDate = endDate;
    this.updatedAt = updatedAt;
  }

  static fromJson(json: Record<string, any>): Event {
    return plainToInstance(Event, json);
  }

  toJson(): any {
    return instanceToPlain(this);
  }
}
